module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.5.5@core-js/library/modules/_library.js
// module id = 111
// module chunks = 0 1